/**
 * 权限控制
 * @see https://umijs.org/docs/max/access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser; }) {
  const {currentUser} = initialState || {};
  const isSuperAdmin = currentUser?.isSuperAdmin === true;
  const permissions: string[] = currentUser?.permissions || [];

  // 构建权限 map：{ 'system:user:add': true, ... }
  const permMap: Record<string, boolean> = {};
  permissions.forEach((p) => {
    permMap[p] = true;
  });

  return {
    isSuperAdmin,
    canAccess: (permCode: string) => isSuperAdmin || permMap[permCode],
    // 动态展开所有权限码为独立属性，方便在组件中用 access['system:user:add'] 直接判断
    ...permMap,
  };
}
